import { faThumbsUp, faTimes } from '@fortawesome/pro-solid-svg-icons';
import './signature-popup.scss'
import { ActionButton } from 'components';
import { HeadingItem } from 'components/heading-item/heading-item';
import { Popup } from 'devextreme-react';
import React, { FC, Fragment } from 'react';

type Props = {
    isVisible: boolean,
    heading: string,
    onClickOk: () => void,
    onClickClear: () => void,
    onClickClose: () => void,
    onContentReady: () => void
}

export const SignaturePopup: FC<Props> = ({ isVisible, heading, onClickOk, onClickClear, onClickClose, onContentReady }) => {

    return (
        <Popup
            onContentReady={onContentReady}
            showCloseButton={true}
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={330}
            height={340}
        >
            <Fragment>
                <HeadingItem
                    text={heading}
                    rightHandIcon={{ icon: faTimes, size: '2x', color: 'black' }}
                    onClick={onClickClose}
                />
                <div className={'signature-popup-box'}>
                    <canvas id="signature-pad" width="300" height="215" className="signature-popup-pad"></canvas>
                </div>
                <div className={'bottom-fix-action-row '}>
                    <ActionButton
                        icon={faTimes}
                        buttonColor={'#EB5757'}
                        onClick={onClickClear}
                        buttonText={'Clear'}
                        iconSize={'1x'}
                    />
                    <ActionButton
                        icon={faThumbsUp}
                        buttonColor={'#76AB21'}
                        onClick={onClickOk}
                        buttonText={'Ok'}
                    />
                </div>
            </Fragment>
        </Popup>
    )
}